import types from "./actions";
import { getCurrentCurrencyLocale } from "../../../utils/CurrencyUtils";

// Get initial state from localStorage
const getInitialState = () => {
  const savedBannerState = localStorage.getItem('welcomeBannerDismissed');
  return {
    isConfirmModalSaveDraftOpen: false,
    issCancelModalOpen: false,
    isWelcomeBannerDismissed: savedBannerState === 'true',
    currencyLocale: getCurrentCurrencyLocale(),
  };
};

const initialState = getInitialState();

export default function reducer(state = initialState, action) {
  // Always ensure currency is correct based on localStorage
  const correctCurrency = getCurrentCurrencyLocale();
  const needsCurrencyCorrection = state.currencyLocale !== correctCurrency;

  if (needsCurrencyCorrection) {
    console.log(
      "🔄 Redux: Correcting currency from",
      state.currencyLocale,
      "to",
      correctCurrency
    );
  }

  switch (action.type) {
    case types.SET_IS_CONFIRM_MODAL_SAVE_DRAFT_OPEN:
      return {
        ...state,
        isConfirmModalSaveDraftOpen: action.isConfirmModalSaveDraftOpen,
        currencyLocale: correctCurrency, // Always ensure correct currency
      };
    case types.SET_IS_CANCEL_MODAL_OPEN:
      return {
        ...state,
        isCancelModalOpen: action.isCancelModalOpen,
        currencyLocale: correctCurrency, // Always ensure correct currency
      };
    case types.SET_WELCOME_BANNER_DISMISSED:
      // Save to localStorage for persistence
      localStorage.setItem('welcomeBannerDismissed', action.isWelcomeBannerDismissed.toString());
      return {
        ...state,
        isWelcomeBannerDismissed: action.isWelcomeBannerDismissed,
        currencyLocale: correctCurrency, // Always ensure correct currency
      };
    case types.SET_CURRENCY_LOCALE:
      console.log(
        "🔄 Redux: Setting currency locale to:",
        action.currencyLocale
      );
      return {
        ...state,
        currencyLocale: action.currencyLocale,
      };

    default:
      // For any other action, ensure currency is correct
      return needsCurrencyCorrection
        ? {
            ...state,
            currencyLocale: correctCurrency,
          }
        : state;
  }
}
